module.exports = __webpack_public_path__ + "img/306.516eba4a.png";